module.exports = __webpack_public_path__ + "static/media/17_Platzek_webfinal.5d171116.jpg";